module.exports = __webpack_public_path__ + "img/towardSimple.29963cbe.svg";